import { appConfig } from "../config/appConfig";

export function PortalFooter() {
  return (
    <footer className="portal-footer">
      <div className="footer-rule" />
      <div className="footer-primary">
        <span className="footer-copyright">
          &copy; 2026 Companion Pharmacy
        </span>
        <p className="footer-support">
          Need help? <a href={`mailto:${appConfig.support.email}`}>{appConfig.support.email}</a>{" "}
          <span aria-hidden="true">&middot;</span>{" "}
          <a href={`tel:${appConfig.support.phoneDigits}`}>{appConfig.support.phone}</a>
        </p>
        <nav aria-label="Legal">
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-service">Terms of Service</a>
        </nav>
      </div>
    </footer>
  );
}
